
// Recommended products for the armpit health basics article
export const armpitHealthBasicsRecommendedProducts = [
  {
    id: 1,
    name: "Grooming Lounge Greatest Pits Deodorant",
    description: "Aluminum-free natural deodorant for sensitive skin.",
    image: "/lovable-uploads/7553ea87-a17e-481c-b7fb-9548fb2ffd93.png",
    link: "https://murphyandmcneil.com/products/grooming-lounge-greatest-pits-deodorant?sca_ref=8468498.oO9QXbgAQO"
  },
  {
    id: 3,
    name: "It Just Works Deodorant",
    description: "Natural deodorant with prebiotics for a healthy microbiome.",
    image: "/lovable-uploads/a38e4978-a37a-452c-a67e-140d9acc3d2e.png",
    link: "https://itjustworksdeodorant.com?sca_ref=8468108.vEEWUNzhD1"
  }
];
